module.exports = __webpack_public_path__ + "f8a8c9e7dad1a6b90aa0154a60cebb56.png";